import { render, staticRenderFns } from "./PrizeOne.vue?vue&type=template&id=cf5c97ca&scoped=true&"
import script from "./PrizeOne.vue?vue&type=script&lang=ts&"
export * from "./PrizeOne.vue?vue&type=script&lang=ts&"
import style0 from "./PrizeOne.vue?vue&type=style&index=0&id=cf5c97ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5c97ca",
  null
  
)

export default component.exports